import React from "react";
import PropTypes from "prop-types";

import {
  Popover,
  Button,
  Icon,
  useMediaQuery,
} from "discover.medical.react-component-library";
import ContentKeyList from "../ContentKeyList";
import { KeyBtnWrapper } from "./ContentKeyMobile.styled";

const ContentKeyMobile = ({ content }) => {
  const isDesktop = useMediaQuery("min", "md");
  const isMobile = useMediaQuery("max", "sm");

  return (
    <KeyBtnWrapper>
      {!isDesktop && (
        <Popover
          data-testid="content-page-key-mobile"
          placement="top"
          trigger={
            <Button variant="accent" size={isMobile ? "sm" : "md"}>
              <Icon
                icon={{
                  glyph: "key",
                  color: "white",
                  size: isMobile ? "xs" : "sm",
                }}
              />
              Key
            </Button>
          }
          popperComponentProps={{
            variant: "secondary",
          }}
        >
          <ContentKeyList keys={content} isMobile={isMobile} />
        </Popover>
      )}
    </KeyBtnWrapper>
  );
};

ContentKeyMobile.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.shape({
        glyph: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        testId: PropTypes.string.isRequired,
      }),
      testId: PropTypes.string.isRequired,
      style: PropTypes.string,
      value: PropTypes.string.isRequired,
    })
  ),
};

ContentKeyMobile.displayName = "ContentKeyMobile";

export default ContentKeyMobile;
